import { render, staticRenderFns } from "./zjManager.vue?vue&type=template&id=195c49b0&scoped=true&"
import script from "./zjManager.vue?vue&type=script&lang=js&"
export * from "./zjManager.vue?vue&type=script&lang=js&"
import style0 from "./zjManager.vue?vue&type=style&index=0&id=195c49b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c49b0",
  null
  
)

export default component.exports